/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { FETCH_SWAGGER_REQUEST, FETCH_SWAGGER_SUCCESS, FETCH_SWAGGER_FAILURE } from '../types/swagger';
import { OpenAPIObject } from 'openapi3-ts';

export const fetchSwaggerRequest = () => {
    return {
        type: FETCH_SWAGGER_REQUEST
    }
 }
 
 export const fetchSwaggerSuccess = (swagger: OpenAPIObject) => {
    return {
        type: FETCH_SWAGGER_SUCCESS,
        payload: swagger
    }
 }
 
 export const fetchSwaggerFailure = (error: string) => {
    return {
        type: FETCH_SWAGGER_FAILURE,
        payload: error
    }
 }
